export default {
  pageDesc: 'SKU-level inventory with bay layout, packaging specs, and grasp readiness',
  newDispatch: '+ New Dispatch',
  kpiSkuCount: 'In-stock SKUs',
  kpiSkuCountSub: 'Top SKUs prioritized',
  kpiGrabOk: 'Robot-ready grasp',
  kpiGrabOkSub: 'Bottle / box standard shapes',
  kpiGrabWarn: 'Pending / unsuitable',
  kpiGrabWarnSub: 'Sheet / soft pack — needs validation',
  kpiAvgWeight: 'Avg. unit weight',
  kpiAvgWeightSub: 'Limit 10kg',
  unitCount: '',
  unitKg: 'kg',
  rackTitle: 'Bay Layout',
  rackHint: '10 racks · A/B faces · 5 layers each · 100 bays; two bins per layer, mixed SKUs allowed',
  rackCodeNotePrefix: 'Bay code: ',
  rackCodeStaticLabel: 'static bay',
  rackCodeRule: '{rack}{face}-{layer}F',
  rackCodeNoteMid: '. e.g. ',
  rackCodeNoteEx1: ' = rack 1 face A layer 2; ',
  rackCodeFullLabel: 'full bay',
  rackCodeFullMid: ' = dock + static bay, e.g. ',
  rackCodeNoteEx2: ' = left dock, rack 1 face A layer 2. Bins are not addressed; columns show 5F → 1F top to bottom.',
  rackFace: 'Face {face}',
  rackName: 'Rack {id}',
  rackUsed: '{used} / 10',
  slotEmpty: 'Empty bay',
  legendFree: 'Empty bay',
  legendSingle: 'Single-SKU bay',
  legendMulti: 'Mixed bay (multiple SKUs)',
  filterGrab: 'Grasp',
  filterGrabAll: 'All',
  filterForm: 'Form',
  filterFormAll: 'All forms',
  formBottle: 'Bottle',
  formBox: 'Box',
  formSheet: 'Sheet',
  formSoft: 'Soft pack',
  filterKw: 'Barcode / SKU / Name',
  filterKwPlaceholder: 'Enter keyword',
  totalCount: '{n} total',
  listTitle: 'SKU Details',
  listHint: 'A bay may hold multiple SKUs; POC has 139 SKUs across 100 bays',
  importSku: 'Import SKUs',
  importSkuTitle: 'Import SKUs',
  importSkuHint: 'Select an Excel file (.xlsx / .xls)',
  importSkuSelect: 'Choose file',
  importSkuDownloadTemplate: 'Download template',
  importSkuDownloadTemplateFail: 'Failed to download template',
  importSkuRequired: 'Please select a file to import',
  importSkuInvalidType: 'Invalid file type. Please upload a .xlsx or .xls file',
  importSkuOk: 'Import',
  importSkuCancel: 'Cancel',
  importSkuSuccess: 'SKUs imported',
  importSkuSuccessCount: 'SKUs imported: {n}',
  importSkuPartial: 'Import finished: {success} succeeded, {fail} failed',
  importSkuFail: 'Failed to import SKUs',
  colWmsId: 'WmsID',
  colSku: 'SKU',
  colBrand: 'Brand',
  colName: 'Product Name',
  colForm: 'Form',
  colWeight: 'Weight',
  colDim: 'Size (L×W×H)',
  colGrab: 'Grasp',
  colAction: 'Action',
  actionEdit: 'Edit',
  actionDelete: 'Delete',
  editTitle: 'Edit Product',
  editOk: 'Save',
  editCancel: 'Cancel',
  editFieldWmsId: 'WmsID',
  editFieldSku: 'SKU',
  editFieldBrand: 'Brand',
  editFieldName: 'Product Name',
  editFieldForm: 'Form',
  editFieldWeight: 'Weight',
  editFieldDim: 'Size (L×W×H)',
  editPlaceholderWmsId: 'Enter WmsID',
  editPlaceholderSku: 'Enter SKU',
  editPlaceholderBrand: 'Enter brand',
  editPlaceholderName: 'Enter product name',
  editPlaceholderWeight: 'Enter weight',
  editPlaceholderDim: 'Enter size, e.g. 300x200x100',
  editRequired: 'Please fill in required fields',
  editSuccess: 'Product updated',
  editFail: 'Failed to update product',
  deleteConfirmTitle: 'Delete this product?',
  deleteConfirmContent: 'This cannot be undone. SKU: {sku}',
  deleteConfirmOk: 'Delete',
  deleteConfirmCancel: 'Cancel',
  deleteSuccess: 'Product deleted',
  deleteFail: 'Failed to delete product',
  grabOk: 'Ready',
  grabPending: 'Pending',
  grabNo: 'Unsuitable',
  empty: 'No matching SKUs',
}
